import { FormProvider, useForm } from "react-hook-form";
import StickyToolbar from "../../../../../Components/StickyToolbar";
import UnForm from "../../../../../Components/Form";
import { ListarEmpreendimentosController } from "../../../../../Controllers/Geral/Produtos/ProdutosControllers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

const filtroInicial = {
    DT_INICIO: moment().format("YYYY-MM-DD"),
    DT_FIM: moment().format("YYYY-MM-DD"),
    ID_EMPREENDIMENTO: 0,
};

interface IFiltroEmpreendimentoResumo {
    filter:
        | {
              DT_INICIO: string;
              DT_FIM: string;
              ID_EMPREENDIMENTO: number;
          }
        | undefined;
    handleFilter(formData: any): void;
}

export default function FiltroEmpreendimentoResumo(
    props: IFiltroEmpreendimentoResumo
) {
    const FormMethods = useForm();
    const { reset } = FormMethods;

    return (
        <StickyToolbar>
            <FormProvider {...FormMethods}>
                <UnForm handleSubmit={props.handleFilter} usingContext>
                    <div className="col-12 mt-3">
                        <label>Data Inicio</label>

                        <UnForm.Input
                            className="form-control"
                            type="date"
                            name="DT_INICIO"
                            defaultValue={props.filter?.DT_INICIO}
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <label>Data Final</label>

                        <UnForm.Input
                            className="form-control"
                            type="date"
                            name="DT_FIM"
                            defaultValue={props.filter?.DT_FIM}
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.LazySelect
                            label="Empreendimento"
                            controller={ListarEmpreendimentosController}
                            getDS={(e) => e.DS_EMPREENDIMENTO}
                            getKeyValue={(e) => e.ID_EMPREENDIMENTO}
                            name="ID_EMPREENDIMENTO"
                            defaultValue={props.filter?.ID_EMPREENDIMENTO}
                        >
                            <option />
                        </UnForm.LazySelect>
                    </div>

                    <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                        <button
                            type="submit"
                            className="btn btn-block btn-outline-dark"
                        >
                            <FontAwesomeIcon icon={faFilter} className="mr-2" />
                            Filtrar
                        </button>
                    </div>
                    <div className="col-12 d-flex align-items-end justify-content-start">
                        <button
                            type="button"
                            onClick={() => {
                                reset(filtroInicial);
                            }}
                            className="btn btn-block btn-outline-danger mt-2"
                        >
                            <FontAwesomeIcon icon={faTimes} className="mr-2" />
                            Limpar Filtros
                        </button>
                    </div>
                </UnForm>
            </FormProvider>
        </StickyToolbar>
    );
}
